import React from "react";
import "./Darkmode1.scss";
import { BsSun, BsMoonFill } from "react-icons/bs";

const DarkMode = () => {
  let clickedClass = "clicked";
  const body = document.body;
  const lightTheme = "light";
  const darkTheme = "dark";
  let theme;

  if (localStorage) {
    theme = localStorage.getItem("theme");
  }
  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme);
  } else {
    body.classList.add(lightTheme);
  }
  const switchTheme = (e) => {
    if (theme === darkTheme) {
      body.classList.replace(darkTheme, lightTheme);
      e.target.classList.remove(clickedClass);
      localStorage.setItem("theme", "light");
      theme = lightTheme;
    } else {
      body.classList.replace(lightTheme, darkTheme);
      e.target.classList.add(clickedClass);
      localStorage.setItem("theme", "dark");
      theme = darkTheme;
    }
  };
  return (
    <button
      className={theme === "dark" ? clickedClass : ""}
      id="darkMode"
      onClick={(e) => switchTheme(e)}
    >
      {" "}
      <BsMoonFill
        style={{ fontSize: "20px", margin: "-6px 0 0 0 ", color: 'white' }}
        className="moon"
      />
      <BsSun
        className="sun"
        style={{
          color: "rgb(255, 255, 255)",
          fontSize: "19px",
          margin: "-6px 0 0 0 ",
        }}
      />
    </button>
  );
};

export default DarkMode;